<!--
 * @Author: jzh
 * @Date: 2020-11-19 15:35:48
 * @LastEditors: DQL
 * @LastEditTime: 2022-02-09 21:45:13
 * @Description: 管理员级别维护
-->
<template>
  <el-row
    v-loading="loading"
    type="flex"
    class="l-page l-page--nav page-user"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :span="8"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            管理员级别
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  ref="adminLevel"
                  class="o-tree-overflow--unset"
                  node-key="adminLevel"
                  highlight-current
                  :data="adminLevelList"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
          </hm-page-card>
        </div>
        <!-- 左侧导航主内容 End -->
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :span="16"
    >
      <!-- 右侧内容：基础详情类布局 Start -->
      <div
        class="l-page--inner l-page--detail"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            管理员列表
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              v-permission-admin-element
              type="primary"
              icon="kestrel-icon ki-sync"
              @click="getAdminUsers()"
            >
              更新数据
            </el-button>
            <el-button
              v-permission-admin-element
              type="success"
              icon="kestrel-icon ki-plus"
              @click="handleAdd()"
            >
              新增
            </el-button>
            <el-button
              v-permission-admin-element
              type="danger"
              icon="kestrel-icon ki-trash"
              plain
              :disabled="multipleSelectedRow.length<=0"
              @click="handleDel(multipleSelectedRow)"
            >
              删除
            </el-button>
          </div>
          <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 页面主内容：详情 Start -->
        <div
          class="l-page__body l-page--detail__body"
        >
          <hm-page-card
            class="c-card--detail"
          >
            <!-- table的ref的命名根据业务名称修改 -->
            <el-table
              ref="listTable"
              class="c-page__table o-header-text-center"
              height="100%"
              stripe
              border
              tooltip-effect="dark"
              :data="pageList"
              :highlight-current-row="true"
              :class="{ 'o-table-empty-center': pageList.length <= 0 }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="30"
                align="center"
              />
              <el-table-column
                prop="userCode"
                label="用户编码"
                min-width="140"
                show-overflow-tooltip
              />
              <el-table-column
                prop="userName"
                label="用户名称"
                min-width="140"
                show-overflow-tooltip
              />
              <el-table-column
                prop="deptName"
                label="所属机构部门"
                min-width="240"
                show-overflow-tooltip
              />
            </el-table>
          </hm-page-card>
        </div>
      </div>
    </el-col>
    <!-- 右侧主面板模块 End -->

    <!-- 新增管理员组件 -->
    <add-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="getAdminUsers"
    />
  </el-row>
</template>

<script>
import AdminLevelManage from '@/features/system/adminLevelManage/index.vue';
export default {
  name: 'SingleAdminLevelManage',
  extends: AdminLevelManage,
  components: {
    addDialog: () => import('./addDialog')
  }
};
</script>
